module.exports = __webpack_public_path__ + "img/bx-arranging.2c046b2d.svg";